import React, { useEffect, useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { getTheme, toggleTheme } from "../../theme";

export default function ThemeToggle({ className = "" }) {
  const [theme, setThemeState] = useState("light");

  useEffect(() => {
    setThemeState(getTheme());
  }, []);

  const onClick = () => setThemeState(toggleTheme());

  return (
    <button
      type="button"
      className={`tv-theme-toggle ${className}`}
      onClick={onClick}
      aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
      title={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
    >
      {theme === "dark" ? <FaSun size={15} /> : <FaMoon size={15} />}
    </button>
  );
}
